import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Code2 } from 'lucide-react';
export function FrontendSection() {
  const points = ['Conversion-focused layout and UX', 'Custom HTML/CSS/JS injected into AEM pages', 'No changes to AEM core required', 'Optimized for all devices'];
  return <section className="h-full flex items-center py-8 px-4 sm:px-6 lg:px-8 bg-white overflow-y-auto lg:overflow-hidden" data-id="element-96">
      <div className="max-w-6xl mx-auto w-full" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mb-8" data-id="element-98">
          <span className="text-xs font-bold tracking-widest text-[#80BC41] uppercase mb-3 block" data-id="element-99">
            02 — Frontend
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1a1a1a] font-heading" data-id="element-100">
            Customized user experience
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-101">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1,
          ease: 'easeOut'
        }} data-id="element-102">
            <div className="mb-6" data-id="element-103">
              <h3 className="text-base font-bold text-[#1a1a1a] mb-4 flex items-center gap-2" data-id="element-104">
                <Code2 className="w-5 h-5 text-[#EB0A1E]" data-id="element-105" />
                Custom Frontend Layer
              </h3>
              <ul className="space-y-3" data-id="element-106">
                {points.map((point, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-107">
                    <CheckCircle2 className="w-5 h-5 text-[#80BC41] shrink-0 mt-0.5" data-id="element-108" />
                    <span className="text-gray-700 font-medium text-sm" data-id="element-109">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-gray-50 rounded-xl p-4 border border-gray-100" data-id="element-110">
              <p className="text-xs text-gray-500 font-medium" data-id="element-111">
                Frontend is decoupled from AEM — we inject optimized code into
                existing pages without modifying the CMS or backend structure.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative" data-id="element-112">
            <div className="relative rounded-2xl overflow-hidden border border-gray-200 shadow-lg bg-white" data-id="element-113">
              <div className="bg-gray-100 px-4 py-2 flex items-center gap-2 border-b border-gray-200" data-id="element-114">
                <div className="flex gap-1.5" data-id="element-115">
                  <div className="w-2.5 h-2.5 rounded-full bg-gray-300" data-id="element-116"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-gray-300" data-id="element-117"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-gray-300" data-id="element-118"></div>
                </div>
                <div className="flex-1 text-center" data-id="element-119">
                  <span className="text-[10px] text-gray-400 font-medium" data-id="element-120">
                    toyota.si/posebna-ponudba
                  </span>
                </div>
              </div>
              <div className="h-[50vh] overflow-y-auto scrollbar-thin" data-id="element-121">
                <img src="https://cdn.magicpatterns.com/uploads/cVJ24KRHpBxGmAqyr6RqH3/Posebna-ponudba-SI-1.jpg" alt="Approved Special Offer landing page design" className="w-full h-auto" data-id="element-122" />
              </div>
            </div>
            <div className="absolute -bottom-2 -right-2 bg-[#EB0A1E] text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-md" data-id="element-123">
              Approved Design
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}